// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2W7tM","filesListContainer":"PosDisputesFiles_filesListContainer__1ZSMq","filesButton":"PosDisputesFiles_filesButton__3-tzt"};